<template>
    <Modal :close_button="true" :size="'modal-md'" mid="confirm-delete-member">
        <template v-slot:header>{{$t('management_console.member_modal.delete_title')}}</template>
        <template v-slot:body>
            <p v-if="member">{{$t('management_console.member_modal.member')}}: <strong>{{member.username}}</strong></p>
            <p>{{$t('management_console.member_modal.delete_description')}}</p>
            <p>{{$t('management_console.member_modal.orders_description')}}</p>
        </template>
        <template v-slot:footer>
            <button type="button" class="btn btn-danger bg-gradient px-4" @click="submit()">{{$t('management_console.common.delete')}}</button>
            <button type="button" class="btn px-4" @click="cancel()">{{$t('controls.cancel')}}</button>
        </template>
    </Modal>
</template>

<script>
import InventoryMemberStore from '@/common/store/inventory_member.js'

export default {
    props: {
        member: {
            type: Object,
            default: () => {}
        }
    },
    data: function () {
        return {
            agree: false
        }
    },
    methods: {
        cancel: async function () {
            this.$bus.$emit('Modal/hide/confirm-delete-member')
        },
        submit: async function () {
            const response = await InventoryMemberStore.dispatch('DELETE_MEMBER', { member_id: this.member.id })
            if (response.status === 0) {
                this.agree = false
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.operation_success'), msg: this.$t('management_console.member_modal.deleted'), level: 'success' })
                this.$bus.$emit('Modal/hide/confirm-delete-member')
            } else {
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.something_went_wrong'), msg: this.$t('notifications.please_retry_the_operation_or_refresh'), level: 'danger' })
            }
        }
    }
}
</script>
